import script from "./DiscountsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscountsPage.vue?vue&type=script&setup=true&lang=js"

import "./DiscountsPage.vue?vue&type=style&index=0&id=1c4e61de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c4e61de"]])

export default __exports__